import type { OutreachRow } from '@discovr/types';
import { isWithBrandStatus } from '@discovr/types';
import { hasRateToHandOff, isCreatorTold } from './handoffStates';
import { fmtAgreedTotal } from './agreedMoney';

export interface BrandPill {
  label: string;
  cls: string;
}

const EMERALD = 'bg-emerald-100 text-emerald-700';
export const AMBER_PILL = 'bg-amber-100 text-[var(--foreground-warning-default)]';
export const ROSE_PILL = 'bg-rose-100 text-rose-700';

/** The with-brand pill vocabulary (D8). Null leaves the row to OutreachStatusPill (incl. "Rate locked"). */
export function brandStatePill(row: Pick<OutreachRow, 'status' | 'brandState' | 'confirmedAt' | 'brandDecidedAt' | 'lastMessage'>): BrandPill | null {
  if (!isWithBrandStatus(row.status)) return null;
  switch (row.brandState ?? 'none') {
    case 'approved':
      if (row.status !== 'accepted_by_brand') return { label: 'Brand approved', cls: EMERALD };
      return { label: isCreatorTold(row) ? 'Brand approved · creator told' : 'Brand approved · tell the creator', cls: EMERALD };
    case 'counter_requested':
      return { label: 'Brand asked for less', cls: AMBER_PILL };
    case 'rejected':
      return { label: 'Brand declined', cls: ROSE_PILL };
    case 'pending':
      return { label: 'With brand · Pending', cls: EMERALD };
    default:
      return null;
  }
}

export function agreedAmountLabel(row: Pick<OutreachRow, 'status' | 'outreachState' | 'agreedDeliverables'>): string | null {
  if (!hasRateToHandOff(row) && !isWithBrandStatus(row.status)) return null;
  const items = row.agreedDeliverables ?? [];
  if (items.length === 0) return null;
  const currencies = new Set(items.map((d) => d.currency ?? 'INR'));
  if (currencies.size !== 1) return null;
  return fmtAgreedTotal(items);
}
